import { Button, Card, Dropdown, Row, Col, Space, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import TableAntd from "components/elements/Table";
import { EyeOutlined, MoreOutlined } from "@ant-design/icons";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useState } from "react";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import dayjs from "dayjs";

const MyTeamAllListTable = ({
    useFilter = false,
    isLoading = false,
    setUseFilter = () => { },
    myTimesheetAllListWithKey = [],
    onPageChange = () => { },
    pagination = {},
    rowSelection = () => { },
    hasSelected = false,
    selectedRowKeys,
    setSelectedRowKeys = () => { },
    onApproveTimesheetByEmployee = () => { },
    onView = () => { },
    projectForApproverOptions = [],
    handleSearch = () => { },
    onRejectedTimesheetByEmployee = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t("employee.label.employee-name")}</div>,
            dataIndex: "employeeFullName",
            key: "employeeFullName",
            render: (_, record) => {
                return (
                    i18n.language === "en" ? record?.fullNameEn : record?.fullName
                )
            }
        },
        {
            title: <div className="text-table">{t('month_request.header')}</div>,
            dataIndex: "monthRequest",
            key: "monthRequest",
            width: 150,
            align: "center",
            render: (_, record) => {
                const monthNumber = record?.monthSubmit;
                const locale = i18n.language === "en" ? "en" : "th";

                return dayjs()
                    .locale(locale)
                    .month(monthNumber - 1)
                    .format("MMMM");
            }
        },
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('my_timesheet.label.project')}</div>,
            dataIndex: "project",
            key: "project",
            render: (_, record) => {
                return (
                    i18n.language === "en" ? record?.projectNameEn : record?.projectName
                )
            }
        },
        {
            title: <div className="text-table">{t('number_list.header')}</div>,
            dataIndex: "numberOfItems",
            key: "numberOfItems",
            width: 150,
            align: "center",
            render: (_, record) => {
                return (
                    `${record?.myTimeSheetCount} ${t("my_timesheet.label.items")}`
                )
            }
        },
        {
            title: <div className="text-table">{t("number_hours.header")}</div>,
            dataIndex: "numberOfHours",
            key: "numberOfHours",
            align: "center",
            width: 150,
            render: (_, record) => {
                let hours = record?.sumWorkingHours ?? 0;
                let minutes = record?.sumWorkingMinutes ?? 0;

                if (minutes >= 60) {
                    hours += Math.floor(minutes / 60);
                    minutes = minutes % 60;
                }

                if (hours > 0 && minutes === 0) {
                    return `${hours} ${t("unit.hour")}`;
                } else if (hours > 0 && minutes > 0) {
                    return `${hours} ${t("unit.hours")} ${minutes} ${t("unit.minute_0")}`;
                } else if (hours === 0 && minutes > 0) {
                    return `${minutes} ${t("unit.minutes")}`;
                } else {
                    return "-";
                }
            }
        },
        {
            title: <div className="text-table">{t("my_timesheet.label.status")}</div>,
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (_, record) => {
                return (
                    <StatusTag
                        value={i18n.language == "en" ? record?.approveStatusEn : record?.approveStatus}
                        text={i18n.language == "en" ? record?.approveStatusEn : record?.approveStatus}
                    />
                )
            }
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: 80,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                {
                                    key: "1",
                                    onClick: () => { onView(record) },
                                    label: `${t("action.view")}`,
                                    icon: (
                                        <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                }
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>)
        }
    ]

    return (
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
            <Row justify={"end"} style={{ gap: "8px" }}>
                <Button type="default"
                    style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", color: "#667085" }}
                    icon={<FilterIcon style={{ fontSize: 16 }} />}
                    onClick={() => setUseFilter(!useFilter)}
                >
                    {t("common.filter")}
                </Button>
            </Row>
            {useFilter && (
                <Card
                    style={{
                        borderRadius: "8px",
                        backgroundColor: "white",
                        border: "1px solid #EAECF0",
                        width: "100%",
                    }}
                >
                    <FormAntd onFinish={handleSearch}>

                        <FormItem shouldUpdate={(prev, curv) => {
                            return false
                        }}>

                            {({ resetFields }) => {
                                return (
                                    <Space direction="vertical" style={{ width: "100%" }}>
                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <FormInput
                                                    name="employeeName"
                                                    label={t('employee.label.employee-name')}
                                                    placeholder={t('common.please_fill')}
                                                    size="large"
                                                />
                                            </Col>
                                            <Col span={8}>
                                                <FormDatePicker
                                                    name="month"
                                                    label={t('month_request.header')}
                                                    placeholder={t('report.please_select')}
                                                    size="large"
                                                    picker="month"
                                                    dateFormat="MMM"
                                                />
                                            </Col>
                                            <Col span={8}>
                                                <FormSelect
                                                    name="projectId"
                                                    label={t('my_timesheet.label.project')}
                                                    placeholder={t('report.please_select')}
                                                    size="large"
                                                    options={projectForApproverOptions}
                                                    allowClear
                                                />
                                            </Col>

                                            <Col span={8} style={{ marginTop: "16px" }}>
                                                <FormSelect
                                                    name="approveStatus"
                                                    label={t('Request.header')}
                                                    placeholder={t("common.pleaseSelect")}
                                                    size="large"
                                                    style={{ width: "100%" }}
                                                    options={[
                                                        { value: 'Complete', label: t("my_timesheet.label.complete") },
                                                        { value: 'Pending', label: t("my_timesheet.label.pending") },
                                                    ]}
                                                />
                                            </Col>
                                        </Row>
                                        <Row gutter={24} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                            <Button
                                                type="default"
                                                onClick={() => resetFields()}
                                                style={{ borderRadius: "8px" }}
                                                size="large"
                                            >
                                                {t("common.cancel").toUpperCase()}
                                            </Button>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                                size="large"
                                            >
                                                {t("common.search").toUpperCase()}
                                            </Button>
                                        </Row>
                                    </Space>
                                )
                            }}
                        </FormItem>
                    </FormAntd>
                </Card>
            )}

            <TableAntd
                columns={columns}
                dataSource={myTimesheetAllListWithKey}
                onChange={onPageChange}
                loading={isLoading}
                pagination={{
                    ...pagination,
                }}
                rowSelection={rowSelection}
                rowKey={(record) => record?.rowKey}
            />

            {hasSelected &&
                (<Flex vertical gap={8} style={{ alignItems: "end" }}>
                    <span>{`${t("common.selected")} ${selectedRowKeys?.length} ${t("my_timesheet.label.items")}`}</span>
                    <Row style={{ gap: "8px" }}>
                        <Button
                            type="default"
                            style={{ borderRadius: "8px", height: "40px" }}
                            onClick={() => {
                                setSelectedRowKeys([]);
                            }}
                        >
                            {t("my_timesheet.label.cancel")}
                        </Button>
                        <Button
                            type="default"
                            style={{ borderRadius: "8px", height: "40px" }}
                            onClick={() => {
                                const selectedRecords = myTimesheetAllListWithKey.filter(item =>
                                    selectedRowKeys.includes(item?.rowKey)
                                );
                                onRejectedTimesheetByEmployee(selectedRecords).then(() => {
                                    setSelectedRowKeys([]);
                                });
                            }}
                        >
                            {t("request_approval.label.not_approved")}</Button>
                        <Button
                            type="primary"
                            style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color" }}
                            onClick={() => {
                                const selectedRecords = myTimesheetAllListWithKey.filter(item =>
                                    selectedRowKeys.includes(item?.rowKey)
                                );
                                onApproveTimesheetByEmployee(selectedRecords).then(() => {
                                    setSelectedRowKeys([]);
                                });
                            }}
                        >{t("request_approval.label.approve")}</Button>
                    </Row>
                </Flex>)}
        </Space>
    )
}

export default MyTeamAllListTable;
